import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/ProductEngineering/5.png"
import { FaCalendarAlt, FaCloud, FaCompass, FaLock, FaPaintBrush, FaReact, FaUserAlt } from "react-icons/fa"
import {GoGraph} from "react-icons/go"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Multi-Cloud & Hybrid Integration
            </h1>
            <p className="text-lg text-gray-600">
            Design solutions that work seamlessly across public, private, or hybrid cloud environments.
			      </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaLock className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Security & Compliance</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Ensure robust security and compliance across different cloud platforms.
			        </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCloud className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cloud Compatibility</h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Solutions that ensure seamless integration across multiple cloud environments.
              </p>
            </div>


          </div>
        </div>

      
      </div>
    </div>
  )
}